import _defineProperty from "/workdir/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { displayMinimumPriceWithoutCurrency } from '../../helpers/product-price';
import AnalyticsDataWrapper from '../analytics-data-wrapper';
import ProductCard from '../product-card';
import { discountedPriceRange, priceRange, discountPercentageRange } from '../../helpers/price-ranges';
import makeUniqueProductId from '../../helpers/make-unique-product-id';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";

const ProductsList = ({
  products,
  page,
  itemsPerPage,
  analytics
}) => products.length === 0 ? null : /*#__PURE__*/_jsx("div", {
  className: style.productsListGrid,
  "data-insights-query-id": analytics === null || analytics === void 0 ? void 0 : analytics.queryID,
  "data-insights-index": analytics === null || analytics === void 0 ? void 0 : analytics.indexName,
  children: products.map((product, index) => {
    var _discountedPriceRange, _product$brand$name, _product$brand, _product$shop$retaile, _product$shop$retaile2, _product$category, _product$category2, _product$variant, _analytics$productLis, _product$variant2;

    const price = (_discountedPriceRange = discountedPriceRange(product)) !== null && _discountedPriceRange !== void 0 ? _discountedPriceRange : priceRange(product);
    const algoliaInsightsIndex = index + 1; // this is the position in the page not the whole set across all pages

    const trackable = {
      'data-ecomm-product': 'product',
      'data-product-brand': (_product$brand$name = (_product$brand = product.brand) === null || _product$brand === void 0 ? void 0 : _product$brand.name) !== null && _product$brand$name !== void 0 ? _product$brand$name : '',
      'data-product-retailer': product.shop.name,
      'data-product-retailer-id': (_product$shop$retaile = (_product$shop$retaile2 = product.shop.retailer) === null || _product$shop$retaile2 === void 0 ? void 0 : _product$shop$retaile2.sys.id) !== null && _product$shop$retaile !== void 0 ? _product$shop$retaile : '',
      'data-product-category': (_product$category = (_product$category2 = product.category) === null || _product$category2 === void 0 ? void 0 : _product$category2[product.category.length - 1]) !== null && _product$category !== void 0 ? _product$category : '',
      'data-product-id': product.variantGroupCode,
      'data-product-unique-id': makeUniqueProductId(product.variantGroupCode, product.shop.id, (_product$variant = product.variant) === null || _product$variant === void 0 ? void 0 : _product$variant.sku),
      'data-product-name': product.name,
      'data-product-price': displayMinimumPriceWithoutCurrency(price),
      'data-product-list': (_analytics$productLis = analytics === null || analytics === void 0 ? void 0 : analytics.productList) !== null && _analytics$productLis !== void 0 ? _analytics$productLis : 'product list',
      'data-product-variant': '',
      'data-product-variant-sku': (_product$variant2 = product.variant) === null || _product$variant2 === void 0 ? void 0 : _product$variant2.sku,
      'data-product-currency': 'AUD',
      'data-product-position': itemsPerPage * page + (index + 1),
      'data-insights-object-id': product.objectID,
      'data-insights-position': algoliaInsightsIndex
    };
    return /*#__PURE__*/_jsx(AnalyticsDataWrapper, _objectSpread(_objectSpread({}, trackable), {}, {
      children: /*#__PURE__*/_jsx(ProductCard, {
        product: product,
        analytics: {
          queryID: analytics === null || analytics === void 0 ? void 0 : analytics.queryID,
          indexName: analytics === null || analytics === void 0 ? void 0 : analytics.indexName,
          position: algoliaInsightsIndex
        },
        priceRange: priceRange(product),
        discountedPriceRange: discountedPriceRange(product),
        discountPercentageRange: discountPercentageRange(product)
      })
    }), [product.variantGroupCode, product.shop.id].join('/'));
  })
});

export default ProductsList;